import { createContext, useContext } from "react";

import type { ISalesPointConfiguration } from "@/api/interfaces/configurationLayouts";

import type {
  SalesPointActions,
  SalesPointContextProps,
  SalesPointState,
} from "./types";

const DEFAULT_STATE: SalesPointState = {
  configuration: {} as ISalesPointConfiguration,
};

export const SalesPointContext = createContext<SalesPointContextProps>([
  DEFAULT_STATE,
  {} as SalesPointActions,
]);

export const useSalesPointContext = () => useContext(SalesPointContext);
